<section>
    <div class="relative mx-auto w-full max-w-7xl items-center px-4 py-8 sm:px-5 sm:py-12 md:px-12 lg:px-24">
        <h1 class="text-center text-2xl font-bold text-black mb-3">Choose Your Color/Size</h1>
        <div class="flex justify-center mb-4 w-full shadow-sm border-t-2 border-purple-700  " >
            
            <!-- <span class="absolute right-4 top-1/2 box-content block h-3 w-3 -translate-y-1/2 "></span>  -->
            <label class="flex cursor-pointer flex-col rounded-2xl  bg-white " >
              <div class="flex flex-col justify-between gap-4 overflow-hidden sm:flex-row sm:items-center" >
              <span class="my-auto break-words text-lg font-semibold text-purple-700 sm:text-xl sm:mr-4" >mobile no 900XXXXXX3 <br>XXXXXXXXX XXXXX XXXXXXX  </span>
              <button class="btncolor w-full dark:bg-gray-600 text-white py-2 px-8 rounded-lg font-bold hover:bg-gray-800 dark:hover:bg-gray-700 shadow-lg sm:w-auto"  >Change Address</button>
          </div>
               </label>
          </div>
        <div class="my-3 flex flex-col gap-4 rounded-lg border-2 border-purple-700 p-4 lg:flex-row">
            <img class="mx-auto h-48 w-full max-w-xs rounded-lg object-cover object-center lg:mx-5 lg:h-72 lg:w-1/3" src="https://via.placeholder.com/150" alt="blog">
<div class="min-w-0 flex-1 lg:mx-5 lg:my-5">
    <h1 class="mx-auto mb-1 text-2xl font-semibold leading-none tracking-tighter text-black lg:text-2xl">Casual Short</h1>
    <p class="mx-auto text-base leading-relaxed text-black">
    sleev soldi women tops  
    </p> 
    <h1 class="text-xl font-bold text-purple-700">Rs.500</h1>               
    
    <div class="mb-4">
        <span class="font-bold text-gray-700 dark:text-gray-300">Select Color:</span>
        <div class="flex items-center mt-2">
            <button class="w-6 h-6 rounded-full bg-gray-800 dark:bg-gray-200 mr-2"></button>
            <button class="w-6 h-6 rounded-full bg-red-500 dark:bg-red-700 mr-2"></button>
            <button class="w-6 h-6 rounded-full bg-blue-500 dark:bg-blue-700 mr-2"></button>
            <button class="w-6 h-6 rounded-full bg-yellow-500 dark:bg-yellow-700 mr-2"></button>
        </div>
    </div>
    <div class="mb-4 flex flex-wrap items-center gap-2" >
        <span class="font-bold text-gray-700 dark:text-gray-300 my-2 mx-1">Select Size:</span>
        <div class="flex flex-wrap items-center gap-2" >
            <button class="bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white py-2 px-4 rounded-full font-bold lg:mr-2 hover:bg-gray-400 dark:hover:bg-gray-600">S</button>
            <button class="bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white py-2 px-4 rounded-full font-bold lg:mr-2 hover:bg-gray-400 dark:hover:bg-gray-600">M</button>
            <button class="bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white py-2 px-4 rounded-full font-bold lg:mr-2 hover:bg-gray-400 dark:hover:bg-gray-600">L</button>
            <button class="bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white py-2 px-4 rounded-full font-bold lg:mr-2 hover:bg-gray-400 dark:hover:bg-gray-600">XL</button>
            <button class="bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white py-2 px-4 rounded-full font-bold lg:mr-2 hover:bg-gray-400 dark:hover:bg-gray-600">XXL</button>
        </div>
       
    </div>
    <button  
    class="btncolor inline-flex w-full justify-center overflow-hidden rounded-lg border border-purple-600 bg-white p-3 text-base font-semibold leading-6 text-white shadow-sm transition ease-in-out duration-150 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:w-auto sm:px-8 sm:text-sm sm:leading-5">
    Submit
</button>

            </div>
        </div>
       
              <div class="relative m-4 sm:m-8 lg:m-16">
                <span class="absolute -z-10  w-full h-full inset-1 bg-violet-500 rounded-xl"></span>
                <button class="absolute py-1 z-10 px-3 -left-8 -top-2 -rotate-[10deg] black_border bg-violet-500 text-white font-bold">
                Note!
            </button>
        
                <div class="rounded-xl border border-black bg-white p-4 sm:p-8 purple_border z-20">
                    Free replacement will be provided within 7 days if the product is delivered in   <span class="font-mono text-purple-700 font-bold">defective/damaged</span> condition or different from the ordered item. Please keep the product intact, with original accessories, user manual and warranty cards in the original packaging at the time of returning the product.
               
                </div>
            </div>
        
              
          
    </div>
</section>